import { InputAdornment, SxProps, TextField } from '@mui/material';
import { useTheme } from '@mui/material/styles';

interface StyledTextFieldProps {
  sx?: SxProps;
  placeholder?: string;
  value?: string | null;
  startIcon?: JSX.Element;
  endIcon?: JSX.Element;
  onKeyPress?: (value: string) => void;
  onChange?: (value: string) => void;
}

export default function StyledTextField({
  sx,
  placeholder,
  value,
  onChange,
  onKeyPress,
  startIcon,
  endIcon
}: StyledTextFieldProps) {
  const theme = useTheme();

  return (
    <TextField
      value={value}
      placeholder={placeholder}
      variant="outlined"
      InputProps={{
        startAdornment: startIcon ? <InputAdornment position="start">{startIcon}</InputAdornment> : null,
        endAdornment: endIcon ? <InputAdornment position="end">{endIcon}</InputAdornment> : null,
        sx: {
          '& input': {
            padding: '12px 16px',
            fontSize: '14px',
            fontWeight: 400,
            textAlign: 'left'
          },
          '& input::placeholder': {
            color: theme.palette.text.secondary,
            opacity: 0.7
          }
        }
      }}
      onChange={(e) => (onChange ? onChange(e.target.value) : null)}
      onKeyDown={(e) => (onKeyPress ? onKeyPress(e.key) : null)}
      sx={{
        backgroundColor: theme.palette.background.default,
        borderRadius: '8px',
        minWidth: '12em',
        transition: 'all 0.2s ease-in-out',
        '& .MuiOutlinedInput-root': {
          borderRadius: '8px',
          '& fieldset': {
            borderColor: 'rgba(0, 0, 0, 0.12)',
            borderWidth: '1px'
          },
          '&:hover fieldset': {
            borderColor: theme.palette.primary.main,
            borderWidth: '2px'
          },
          '&.Mui-focused fieldset': {
            borderColor: theme.palette.primary.main,
            borderWidth: '2px',
            boxShadow: `0 0 0 3px ${theme.palette.primary.main}20`
          }
        },
        '& .MuiSvgIcon-root': {
          fontSize: '20px',
          color: theme.palette.text.secondary,
          transition: 'color 0.2s ease-in-out'
        },
        '&:hover .MuiSvgIcon-root': {
          color: theme.palette.primary.main
        },
        ...sx
      }}
    />
  );
}
